const $body = $('body'),
    $menuBar = $('.menu-bar');

// menu-toggle
$('[data-toggle="menu"]').on('click', function (e) {
    e.preventDefault();

    if ($body.hasClass('show-menu')) {
        $body.removeClass('show-menu');
        $('.page-wrapper').trigger('lenisStart');
    } else {
        $body.addClass('show-menu');
        $('.page-wrapper').trigger('lenisStop');
    }
});

// actions on key press
$(document).keyup(function(e) {
    if (e.key === "Escape") {
        $body.removeClass('show-menu');
        $('.page-wrapper').trigger('lenisStart');
    }
});

$('.page-wrapper__fade-layer').on('click', function() {
    $body.removeClass('show-menu');
    $('.page-wrapper').trigger('lenisStart');
});
